export default __webpack_public_path__ + "static/media/BH Icons 30 p_Parking.76c792d4.svg";